import { colors } from '@styles/vars/colors.style'
import {
  getCustomTextStyle,
  TextBody,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'


export const BrandsMain = styled.section`
  color: ${props => props.color};
  background-color: ${props => props.background};
  .grid {
    justify-content: center;
  }

${TextBody} {
  ${getCustomTextStyle(
    textStylesConfig.heading2Serif,
    textStylesConfig.heading1Serif
    )}
  }
  `
  
export const BrandTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading4Sans, textStylesConfig.caption)}
`

export const BrandsImage = styled.div`
  max-height: 170px;
  [data-main-image] {
    object-fit: contain !important;
    max-height: 170px;
  }
`
